import request from '@/utils/server'

// 获取小程序在售菜品
export function getRecord(query) {
    return request({
      url: '/disinfectionCabinet/getRecord',
      method: 'get',
      params: query
    })
  }